import React from "react";

export const SelectedCodeLanguageContext = React.createContext({
  codeLanguage: "python",
  setCodeLanguage: {},
});
